import { Modal } from '@safetyhub/ui';
import { useUsageStore, getTimeUntilReset } from '../stores/usage';

export default function UsageExhaustedModal() {
  const { usage, showExhaustedModal, setShowExhaustedModal, exhaustedType } = useUsageStore();

  if (!showExhaustedModal || !usage) return null;

  const timeUntilReset = getTimeUntilReset(usage.nextResetAt);
  const typeLabel = exhaustedType === 'photo' ? '사진 업로드' : '점검 생성';

  const close = () => setShowExhaustedModal(false);

  // 아이콘 가운데 정렬 안내형이라 헤더 제목을 두지 않는다(제목은 본문 h3) — ✕는 base 헤더가 그린다.
  return (
    <Modal open onClose={close} ariaLabel={`오늘의 ${typeLabel} 한도 소진`} size="md">
          {/* 아이콘 */}
          <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-amber-100 mb-4">
            <svg className="h-6 w-6 text-amber-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
          </div>

          {/* 헤더 */}
          <h3 className="text-lg font-bold text-ink-900 text-center mb-2">
            오늘의 {typeLabel} 한도를 모두 사용했습니다
          </h3>
          <p className="text-sm text-ink-600 text-center mb-6">
            일일 사용량이 초기화될 때까지 기다려주세요.
          </p>

          {/* 사용량 현황 */}
          <div className="bg-surface-soft rounded-card p-4 mb-6">
            <div className="flex justify-between items-center mb-3">
              <span className="text-sm text-ink-600">사진 업로드</span>
              <span className="text-sm font-medium">
                {usage.photoCount} / {usage.photoLimit}장
              </span>
            </div>
            <div className="w-full bg-ink-200 rounded-full h-2 mb-4">
              <div
                className={`h-2 rounded-full ${usage.photoCount >= usage.photoLimit ? 'bg-red-500' : 'bg-brand-500'}`}
                style={{ width: `${Math.min((usage.photoCount / usage.photoLimit) * 100, 100)}%` }}
              />
            </div>

            <div className="flex justify-between items-center mb-3">
              <span className="text-sm text-ink-600">점검 생성</span>
              <span className="text-sm font-medium">
                {usage.inspectionCount} / {usage.inspectionLimit}회
              </span>
            </div>
            <div className="w-full bg-ink-200 rounded-full h-2">
              <div
                className={`h-2 rounded-full ${usage.inspectionCount >= usage.inspectionLimit ? 'bg-red-500' : 'bg-brand-500'}`}
                style={{ width: `${Math.min((usage.inspectionCount / usage.inspectionLimit) * 100, 100)}%` }}
              />
            </div>
          </div>

          {/* 초기화 안내 */}
          <div className="text-center mb-4">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-brand-50 rounded-card">
              <svg className="h-5 w-5 text-brand-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              <span className="text-sm text-brand-700 font-medium">
                {timeUntilReset} 초기화
              </span>
            </div>
          </div>

          {/* 확인 버튼 */}
          <button
            onClick={close}
            className="w-full py-3 px-4 bg-ink-900 text-white rounded-card-sm font-medium hover:bg-ink-800 transition-colors"
          >
            확인
          </button>
    </Modal>
  );
}
